<div class="col-xs-12 accesos order-3 or">
    <div class="text-present font-weight-bold text-primary mt-4 mb-4">
      ¿Qué vas a realizar?
    </div>

    <div class="d-flex flex-wrap justify-content-center">
      <div class="col-md-2 col-5 card-acceso">
        <a
          [routerLink]="['/transferencia-interna']"
          class="d-flex flex-column align-items-center text-decoration-none"
        >
          <span class="material-icons icono">
            transfer_within_a_station
          </span>
          <p class="text-acceso text-center mt-2">
            Transferencia Interna
          </p>
        </a>
      </div>

      <div class="col-md-2 col-5 card-acceso">
        <a
          [routerLink]="['/transferencia-externa']"
          class="d-flex flex-column align-items-center text-decoration-none"
        >
          <span class="material-icons icono"> sync_alt </span>
          <p class="text-acceso text-center mt-2">
            Transferencia Interbancaria
          </p>
        </a>
      </div>

      <div class="col-md-2 col-5 card-acceso">
        <a
          [routerLink]="['/pago-servicios']"
          class="d-flex flex-column align-items-center text-decoration-none"
        >
          <span class="material-icons icono"> lightbulb </span>
          <p class="text-acceso text-center mt-2">Pago de Servicios</p>
        </a>
      </div>

      <div class="col-md-2 col-5 card-acceso">
        <a
          [routerLink]="['/recaudaciones-gadriobamba']"
          class="d-flex flex-column align-items-center text-decoration-none"
        >
          <span class="material-icons icono"> domain </span>
          <p class="text-acceso text-center mt-2">
            Pago de Recaudaciones
          </p>
        </a>
      </div>
    </div>
  </div>